const assert = require('assert');

const merge = require('lodash.merge');

const {get, gql} = require('./agent');

module.exports = (global_options) => {
  return {
    get: (id, local_options) => {
      const options = merge({}, global_options, local_options);
      return get(`/allocations/${id}`, options);
    },
    w9: (id, local_options) => {
      const options = merge({}, global_options, local_options);
      return get(`/allocations/${id}/w9`, options);
    },
    signed: (id, local_options) => {
      const options = merge({}, global_options, local_options);
      return get(`/allocations/${id}/signed`, options);
    },
    sign: (id, local_options) => {
      const options = merge({}, global_options, local_options);
      const mutation = `
        mutation M {
          allocation: sign_docs(id:  "${id}") {
            id
            documents {
              signed
            }
          }
        }
      `;
      return gql(mutation, null, options);
    },  }
}



// WEBPACK FOOTER //
// ../covert/allocations.js